import { useState, useRef, useEffect } from 'react';
import useApi from "./useApi";

function useLocality () {
    const [localitiesByPostalCode, setLocalitiesByPostalCode] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const localitiesByPostalCodeApi = useApi('locality/GetLocalitiesByPostalCode');
    const localitiesByPostalCodeLoad = useRef(true);

    useEffect(() => {
        if (localitiesByPostalCodeLoad.current) {
            localitiesByPostalCodeLoad.current = false;
            return;
        }

        setLocalitiesByPostalCode(localitiesByPostalCodeApi.data);
        setLoading(localitiesByPostalCodeApi.loading);
        setError(localitiesByPostalCodeApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localitiesByPostalCodeApi]);

    const getByPostalCode = async (countryId, postalCode) => {
        setLoading(true);
        localitiesByPostalCodeApi.get({
            countryId: countryId,
            postalCode: postalCode
        });
    }

    return {
        localitiesByPostalCode,
        error,
        loading,
        getByPostalCode
    };
}

export default useLocality;